import { AlphaWBoxIcon } from './AlphaWBoxIcon';

/**
 * author: GreenTurtwig
 * id E63E39FF-8E9F-470F-9CDD-55B2703E620A
 * name alpha-w-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterWBoxIcon = AlphaWBoxIcon;
export default LetterWBoxIcon